import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CREDENCIADOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterContratacoes() {
        return axiosJwt
            .get(`${api}/credenciados/gerentes/gestoresdesignados/contratacoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    // obterPorId(contratacaoId) {
    //     return axiosJwt
    //         .get(`${api}/credenciados/gerentes/contratacoes/${contratacaoId}`)
    //         .then(response => {
    //             return response.data
    //         })
    //         .catch(error => {
    //             return errorHandler(error)
    //         })
    // },

    obterColaboradoresDisponiveis() {
        return axiosJwt
            .get(
                `${api}/credenciados/gerentes/gestoresdesignados/colaboradoresdisponiveis`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    designarGestor(designacaoGestorDto) {
        return axiosJwt
            .post(
                `${api}/credenciados/gerentes/gestoresdesignados/designargestor`,
                designacaoGestorDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirGestorDesignado(exclusaoGestorDesignadoDto) {
        return axiosJwt
            .post(
                `${api}/credenciados/gerentes/gestoresdesignados/excluirgestordesignado`,
                exclusaoGestorDesignadoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
